import React from 'react';
import styled from 'styled-components';

const IssueRequest = styled.svg`
	width: 56px;
	height: 56px;
	position: relative;
	.cls-1 {
		fill: #a2a9ad;
	}
	.cls-2 {
		fill: ${props => props.theme.Cool_Gray_Light_3};
	}
	.cls-3 {
		isolation: isolate;
	}
	&.medium {
		width: 80px;
		height: 80px;
	}
	&.large {
		width: 136px;
		height: 136px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		svg {
			width: 80px !important;
			height: 80px !important;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		width: 136px;
		height: 136px;
	}
`;

export const CogSVG = ({ className, id }) => {
	return (
		<IssueRequest
			xmlns='http://www.w3.org/2000/svg'
			width='126'
			height='128.023'
			viewBox='0 0 136 128.023'
			id={id}
			className={className}
		>
			<defs>
				<linearGradient
					id={`${id}-linear-gradient-cog`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#8060a9'>
						<animate
							id={`${id}trans1`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#a2a9ad'>
						<animate
							id={`${id}trans1`}
							dur='1s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id={`${id}-linear-gradient-cog-2`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#8060a9'>
						<animate
							id={`${id}trans3`}
							dur='0.5s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#edefef'>
						<animate
							id={`${id}trans3`}
							dur='0.5s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(35)'
				>
					<stop offset='0' stop-color='#edefef'>
						<animate
							id={`${id}trans2`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#8060a9'>
						<animate
							id={`${id}trans2`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<g id='issue-request-element-hover-136_px'>
				<g id='_2560-question-cog-element-default'>
					<g id='_2560-question-cog-element-default-2'>
						<path
							id='_2560-question-cog'
							d='M64.673 1.61H43.408l-1.422 12.38a40.156 40.156 0 0 0-7.186 2.98l-9.759-7.762L10.007 24.26l7.743 9.754a40.8 40.8 0 0 0-2.97 7.186L2.4 42.618v21.265L14.78 65.3a41.089 41.089 0 0 0 2.971 7.182l-7.744 9.758 15.034 15.043 9.759-7.752a39.469 39.469 0 0 0 7.182 3l1.422 12.38h21.269l1.422-12.38a40.011 40.011 0 0 0 7.182-2.971l9.753 7.75 15.007-15.07-7.716-9.754a40.4 40.4 0 0 0 2.97-7.186l12.38-1.422v-21.26L93.291 41.2a40.13 40.13 0 0 0-2.971-7.182l7.716-9.754L83.03 9.208l-9.754 7.762a40.753 40.753 0 0 0-7.182-2.98z'
							class='cls-1'
							transform='translate(-2.4 -1.61)'
						/>
					</g>
					<g id='_2560-question' transform='translate(36.315 28.302)'>
						<g id='_2560-question-default'>
							<path
								id='period'
								d='M54.16 82.632h11.167l.018-10.832H54.187z'
								class='cls-2'
								transform='translate(-43.599 -36.534)'
							/>
							<path
								id='top'
								d='M59.254 32.86c-10.089 0-17.533 4.184-16.691 19.725H53.82a19.017 19.017 0 0 1-.32-3.795c.127-3.079.969-6.756 4.673-6.756 2.364 0 3.623 1.911 3.623 4.2 0 3.74-2.309 5.633-4.872 7.933-3.26 3.007-3.451 4.718-3.523 9.111v.906h10.68c.127-2.826 2.11-4.066 3.768-5.307 4.293-3.215 7.363-5.9 7.372-11.864.018-9.426-7.58-14.153-15.967-14.153z'
								class='cls-2'
								transform='translate(-42.498 -32.86)'
							/>
						</g>
					</g>
				</g>
				<g id='_2560-exclamation-cog-element-default' transform='translate(54.845 47.42)'>
					<g id='exclamation-gradient-cog-element-default' class='cls-3'>
						<g id='cog-highlight'>
							<path
								id='Path_92589'
								d='M128.27 132.991l6 4.773 1.675 1.1-7.517-5.959z'
								class='cls-2'
								transform='translate(-72.228 -64.162)'
							/>
							<path
								id='Path_92590'
								d='M145.281 91.7h.045l9.636 1.132-1.648-1.1L145 90.78c.082.299.19.607.281.92z'
								class='cls-2'
								transform='translate(-73.807 -60.187)'
							/>
							<path
								id='Path_92591'
								d='M72.268 75.044l5.941 7.508a31.018 31.018 0 0 0-2.291 5.524l-9.527 1.1v16.365l1.648 1.1V90.268l9.527-1.1c.145-.471.308-.906.471-1.422.344-.906.725-1.811 1.15-2.717.217-.453.444-.906.679-1.34l-5.95-7.553 11.547-11.57-1.648-1.1z'
								class='cls-2'
								transform='translate(-66.39 -57.61)'
							/>
							<path
								id='Path_92592'
								d='M100.08 134.88l1.005 8.966 1.685 1.1-1.1-9.536c-.53-.159-1.07-.34-1.59-.53z'
								class='cls-2'
								transform='translate(-69.569 -64.348)'
							/>
							<path
								id='Path_92593'
								d='M80.446 117.858a31.225 31.225 0 0 1-2.273-5.524l-1.34-.154a30.484 30.484 0 0 0 1.965 4.583l-5.978 7.507 11.547 11.565 1.694 1.114-11.584-11.583z'
								class='cls-2'
								transform='translate(-66.997 -62.206)'
							/>
							<path
								id='Path_92594'
								d='M100.538 57l-1.114 9.509c-.489.145-.978.308-1.458.489l-.471.172c-.326.127-.652.245-.969.38a.181.181 0 0 0-.072 0c-.281.109-.552.235-.824.362-.489.226-.969.453-1.449.706l-.118.054-.163.1 1.648 1.1c.426-.226.851-.435 1.286-.643l.444-.2c.3-.136.589-.272.906-.389s.634-.254.951-.371l.48-.19q.725-.254 1.467-.489l1.1-9.527h16.356L116.894 57z'
								class='cls-2'
								transform='translate(-68.986 -57)'
							/>
							<path
								id='Path_92595'
								d='M95.575 69.9c.426-.226.851-.435 1.286-.643l.444-.2c.3-.136.589-.272.906-.389s.634-.254.951-.371l.48-.19q.725-.254 1.467-.489l.978-8.4.127-1.123h16.356L116.912 57h-16.356l-1.114 9.509c-.489.145-.978.308-1.458.489l-.471.172c-.326.127-.652.245-.969.38a.18.18 0 0 0-.072 0c-.281.109-.552.235-.824.362-.489.226-.969.453-1.449.706l-.109.054z'
								class='cls-2'
								transform='translate(-69.003 -57)'
							/>
							<path
								id='Path_92596'
								d='M126.2 69.378a29.893 29.893 0 0 0-3.931-1.757l.063.571a30.42 30.42 0 0 1 5.534 2.282l7.517-5.968-1.666-1.1z'
								class='cls-2'
								transform='translate(-71.662 -57.605)'
							/>
						</g>
						<path
							id='cog-gradient'
							d='M116.144 58.19H99.761l-1.1 9.536a31.263 31.263 0 0 0-5.524 2.282l-7.513-5.968-11.583 11.584 5.968 7.517a31.266 31.266 0 0 0-2.282 5.524l-9.536 1.1v16.383l9.536 1.087a31.075 31.075 0 0 0 2.282 5.534l-5.968 7.517 11.583 11.574 7.517-5.959a31.262 31.262 0 0 0 5.524 2.282l1.1 9.536h16.383l1.087-9.536a31.072 31.072 0 0 0 5.534-2.282l7.517 5.959 11.574-11.574-5.959-7.517a31.071 31.071 0 0 0 2.282-5.534l9.537-1.087V89.761l-9.537-1.1a31.26 31.26 0 0 0-2.282-5.524l5.959-7.517-11.579-11.58-7.517 5.968a31.072 31.072 0 0 0-5.534-2.282l-1.087-9.536z'
							class='cls-1'
							transform='translate(-66.56 -57.112)'
						/>
					</g>
					<g id='exclamation-gradient' transform='translate(36.099 23.474)'>
						<g id='exclamation-gradient-2' class='cls-3'>
							<path
								id='period-2'
								d='M108.03 121.93l.018-8.83h9.337l-.018 8.83z'
								class='cls-2'
								transform='translate(-106.418 -85.767)'
							/>
							<path
								id='top-2'
								d='M115.877 107.246h-6.783L106.25 82.92h12.715z'
								class='cls-2'
								transform='translate(-106.25 -82.92)'
							/>
						</g>
					</g>
				</g>
			</g>
		</IssueRequest>
	);
};
